import { ReactComponent as Logo } from './Logo_white.svg'

export default Logo
